import { Private_Routes } from '@common/url';
import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import React from 'react';
import { useParams } from 'react-router-dom';

import { Error } from '../Import/utils';
import { useIsBulkTranspiledPipeline } from '../useIsBulkTranspiledPipeline';
import { ImportedInfo } from './index';

export default function PackageDetail() {
  const { version, isBulk } = useIsBulkTranspiledPipeline();

  const params = useParams<ExtractUrlPathVariables<typeof Private_Routes.TranspilerDetail.url>>();
  const uid = params.uid;
  if (!uid || !params.type) {
    return <Error message='Not a valid transpiler id' />;
  }

  return <ImportedInfo isBulk={isBulk} id={uid} version={version} type={params.type} />;
}
